import type { USP } from "../../aysa_api/models/usp.types";
import { Reader, Writer } from "protobufjs/minimal";
import {
  createBaseImage,
  encodeImage,
  decodeImage,
} from "../../aysa_api/models/image";
import {
  encodeProgressUntilFreeDeliverySection,
  decodeProgressUntilFreeDeliverySection,
} from "../../aysa_api/models/basket_mov";

export const createBaseUSP = (): USP => {
  return {
    label: "",
    image: createBaseImage(),
    isVip: false,
    isSecondHand: false,
  };
};

export const decodeUSP = (reader: Reader, length: number): USP => {
  const end = reader.pos + length;
  const message = createBaseUSP();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.href = reader.string();

        break;
      case 2:
        message.label = reader.string();

        break;
      case 3:
        message.image = decodeImage(reader, reader.uint32());

        break;
      case 4:
        message.isVip = reader.bool();

        break;
      case 5:
        message.isSecondHand = reader.bool();

        break;
      case 6:
        message.freeDeliveryProgressSection =
          decodeProgressUntilFreeDeliverySection(reader, reader.uint32());

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeUSP = (writer: Writer, message: USP): Writer => {
  if (message.href !== undefined) {
    writer.uint32(10).string(message.href);
  }
  writer.uint32(18).string(message.label);
  encodeImage(writer.uint32(26).fork(), message.image).ldelim();
  writer.uint32(32).bool(message.isVip);
  writer.uint32(40).bool(message.isSecondHand);
  if (message.freeDeliveryProgressSection !== undefined) {
    encodeProgressUntilFreeDeliverySection(
      writer.uint32(50).fork(),
      message.freeDeliveryProgressSection
    ).ldelim();
  }

  return writer;
};
